import { connect } from "react-redux";
export function ReduxConnect(mapStateToProps) {
    return function decorator(constructor) {
        return connect(mapStateToProps)(class extends constructor {
        });
    };
}
